/** Tracks the user turned down from recommendations (smart shuffle ✕,
 *  "Enrichir" ✕) — sent as exclusions so they don't come back. */
const KEY = "sl.notInterested";
const MAX = 500;

export function getNotInterested(): string[] {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch { return []; }
}

export function addNotInterested(id: string) {
  const list = getNotInterested().filter((x) => x !== id);
  list.unshift(id);
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch { /* ignore */ }
}
